import React from 'react';

import { Provider as StoreProvider } from 'react-redux';
import { injectStore } from '../../api/HttpClient';
import { initialStoreCongig, store } from '../../store';

interface ReduxStoreProviderProps {
  children: React.ReactNode;
}

injectStore(initialStoreCongig.store);

export const ReduxStoreProvider = ({ children }: ReduxStoreProviderProps) => {

  return (
    <StoreProvider store={store}>
      {children}
    </StoreProvider>
  );
};
